import { isArray } from 'lodash';
import { createContext, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { isObjInArray } from 'coreOld/utils';
import { IPill } from 'partsOld/types';

interface IDragAndDropContext {
  pills: IPill[];
  addPills: (pills: IPill[] | IPill) => void;
  removePills: (pills: IPill[]) => void;
  clearPills: () => void;
}

export const DragAndDropContext = createContext<IDragAndDropContext | undefined>(undefined);

export const DragAndDropProvider = ({ children }: { children }) => {
  const [pills, setPills] = useState([]);

  const addPills = (data: IPill[] | IPill) => {
    if (isArray(data)) {
      setPills([...pills, ...data]);

      return;
    }

    setPills((prev) => [...prev, data]);
  };

  const removePills = (pillList: IPill[]) => {
    const items = pills.filter((element) => !isObjInArray(element, 'id', pillList));

    setPills(items);
  };

  const clearPills = () => setPills([]);

  return (
    <DragAndDropContext.Provider
      value={{
        addPills,
        removePills,
        clearPills,
        pills,
      }}
    >
      <DndProvider backend={HTML5Backend}>{children}</DndProvider>
    </DragAndDropContext.Provider>
  );
};
